export enum OrdersTotalsType {
  Canceled = 'canceled',
  Completed = 'completed',
  Draft = 'draft',
  NotScheduled = 'notScheduled',
  Dispatched = 'dispatched',
  OnHold = 'onHold',
  PartiallyScheduled = 'partiallyScheduled',
  Pending = 'pending',
  Scheduled = 'scheduled',
  Started = 'started',
  Total = 'total',
}
